{
    "//": "THIS FILE IS AUTOGENERATED. DO NOT EDIT MANUALLY. To update: pnpm run schema:build",
    "CalendarHeatmapQuery": 2,
    "FunnelsQuery": 2,
    "LifecycleQuery": 2,
    "RetentionQuery": 2,
    "StickinessQuery": 4,
    "TrendsQuery": 4
}
